module.exports = __webpack_public_path__ + "media/BUTTON_SWITCH.0830fc07.mp3";